module.exports = __webpack_public_path__ + "static/media/camcorder.cbe39bc9.svg";